import * as React from 'react';

import GlobalTranz from '../assets/globaltranz-logo.png';

export default function GlobalTranzLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={GlobalTranz} alt='GlobalTranz Logo' {...props} />;
}
